import { css } from 'styled-components';
import { mediaTemplates } from 'theme/variables';

export const embedWrapper = css`
  &:nth-child(2) {
    padding-top: 27px;
    ${mediaTemplates.l} {
      padding-top: 39px;
    }
  }
`;
